import { ActionType, ActionTypes, State } from './types';

const initialState = {
  isLoading: false,
  error: '',
  data: [],
};

const legacyEvaluationsReducers = (state: State = initialState, action: ActionType): State => {
  switch (action.type) {
    case ActionTypes.FETCH_EVALUATIONS_START:
      return {
        ...state,
        isLoading: true,
      };
    case ActionTypes.FETCH_EVALUATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: [...action.payload],
      };
    case ActionTypes.FETCH_EVALUATIONS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case ActionTypes.CLEAR_EVALUATIONS:
      return {
        ...state,
        data: [],
      };
    default:
      return state;
  }
};

export default legacyEvaluationsReducers;
